import { createContext, useContext } from "react";

export interface NavContentContextType {
  sections: string[];
  selectedSection: string;
  setSelectedSection: (section: string) => void;
}

export const NavContentContext = createContext<NavContentContextType | undefined>(
  undefined
);

export const useNavContentContext = () => {
  const ctx = useContext(NavContentContext);

  if (!ctx) {
    throw new Error("useNavContentContext must be used within <NavContent>");
  }

  return ctx;
};
